const initialState = {
    messages: [], // Array of { sender: 'user'|'bot', text: string, databaseTimeMs?: number, apiTimeMs?: number, isStreaming?: boolean }
    history: [],  // Array of { id: string, title: string, messages: array, timestamp: number }
    loading: false,
    databaseTimeMs: 0,
    apiTimeMs: 0,
    error: null,
    errorStatus: null, // 'api_error' | 'server_error' | 'network_error'
    activeSessionId: null
};

const ChatbotReducers = (state = initialState, action) => {
    switch (action.type) {
        case "CHATBOT_LOAD_HISTORY":
            return {
                ...state,
                history: action.history || []
            };

        case "CHATBOT_SET_LOADING":
            return {
                ...state,
                loading: action.loading
            };

        case "CHATBOT_SET_ERROR":
            return {
                ...state,
                error: action.error,
                errorStatus: action.errorStatus || null
            };

        case "CHATBOT_ADD_MESSAGE":
            return {
                ...state,
                messages: [...state.messages, action.message]
            };

        case "CHATBOT_UPDATE_STREAMING_CHUNK": {
            const updatedMessages = [...state.messages];
            if (updatedMessages.length > 0) {
                const last = updatedMessages[updatedMessages.length - 1];
                if (last.sender === 'bot') {
                    updatedMessages[updatedMessages.length - 1] = {
                        ...last,
                        text: last.text + action.text,
                        databaseTimeMs: action.databaseTimeMs !== undefined ? action.databaseTimeMs : last.databaseTimeMs,
                        apiTimeMs: action.apiTimeMs !== undefined ? action.apiTimeMs : last.apiTimeMs
                    };
                }
            }
            return {
                ...state,
                messages: updatedMessages,
                databaseTimeMs: action.databaseTimeMs !== undefined ? action.databaseTimeMs : state.databaseTimeMs,
                apiTimeMs: action.apiTimeMs !== undefined ? action.apiTimeMs : state.apiTimeMs
            };
        }

        case "CHATBOT_FINISH_STREAMING": {
            const updatedMessages = [...state.messages];
            if (updatedMessages.length > 0) {
                const last = updatedMessages[updatedMessages.length - 1];
                if (last.sender === 'bot') {
                    updatedMessages[updatedMessages.length - 1] = {
                        ...last,
                        isStreaming: false
                    };
                }
            }
            return {
                ...state,
                messages: updatedMessages,
                loading: false
            };
        }

        case "CHATBOT_LOAD_SESSION":
            return {
                ...state,
                activeSessionId: action.sessionId,
                messages: action.messages || [],
                databaseTimeMs: action.databaseTimeMs || 0,
                apiTimeMs: action.apiTimeMs || 0,
                error: null,
                errorStatus: null,
                loading: false
            };

        case "CHATBOT_CLEAR_CHAT":
            return {
                ...state,
                messages: [],
                databaseTimeMs: 0,
                apiTimeMs: 0,
                error: null,
                errorStatus: null
            };

        case "CHATBOT_START_NEW_CHAT":
            return {
                ...state,
                activeSessionId: action.sessionId,
                messages: [],
                databaseTimeMs: 0,
                apiTimeMs: 0,
                error: null,
                errorStatus: null,
                loading: false
            };

        case "CHATBOT_DELETE_HISTORY":
            return {
                ...state,
                history: [],
                messages: [],
                activeSessionId: null,
                databaseTimeMs: 0,
                apiTimeMs: 0,
                error: null,
                errorStatus: null,
                loading: false
            };

        default:
            return state;
    }
};

export default ChatbotReducers;
